import styled from 'styled-components'
// import { CloneBidAnnouncement } from 'components/Molecules/Announcements/CloneBid.announcement'
// import { DegenCompetition } from 'components/Molecules/Announcements/DegenCompetition'
import { YolocoasterAnnouncement } from 'components/Molecules/Announcements/Yolocoaster.announcement'

export const YoloStaticLeftContent = () => {
  return (
    <AnnouncementWrapper>
      {/* <DegenCompetition /> Hidded intentionally, it will be reactivated in the future*/}
      <YolocoasterAnnouncement />
      {/* <CloneBidAnnouncement /> */}
    </AnnouncementWrapper>
  )
}

const AnnouncementWrapper = styled.div`
  width: 100%;
  padding: 15px 20px;
  background: hsla(216, 100%, 64%, 0.1);

  & div:last-child div {
    padding: 0;
    border-bottom: none;
  }
`
